
import type { Dispatch } from 'redux';

import UIEvents from '../../../../service/UI/UIEvents';
import { createAudioOnlyChangedEvent, sendAnalytics } from '../../analytics';

import { SET_AUDIO_ONLY, SET_CARMODE_AUDIO_ONLY } from './actionTypes';
import logger from './logger';


declare var APP: Object;

/**
 * Sets the audio-only flag for the current MHConference.
 *
 * @param {boolean} audioOnly - True if the conference should be audio only;
 * false, otherwise.
 * @param {boolean} ensureVideoTrack - Define if conference should ensure
 * to create a video track.
 * @returns {{
 *     type: SET_AUDIO_ONLY,
 *     audioOnly: boolean,
 *     ensureVideoTrack: boolean
 * }}
 */
export function setAudioOnly(audioOnly: boolean, ensureVideoTrack: boolean = false) {
    return (dispatch: Dispatch<any>, getState: Function) => {
        const { enabled: oldValue } = getState()['features/base/audio-only'];

        if (oldValue !== audioOnly) {
            sendAnalytics(createAudioOnlyChangedEvent(audioOnly));
            logger.log(`Audio-only ${audioOnly ? 'enabled' : 'disabled'}`);

            dispatch({
                type: SET_AUDIO_ONLY,
                audioOnly,
                ensureVideoTrack
            });

            if (typeof APP !== 'undefined') {
                // TODO This should be a temporary solution that lasts only until video
                // tracks and all ui is moved into react/redux on the web.
                APP.UI.emitEvent(UIEvents.TOGGLE_AUDIO_ONLY, audioOnly);
            }
        }
    };
}

/**
 * Sets the audio-only flag for the Car Mode MHConference.
 *
 * @param {boolean} audioOnlyCarMode - True if the conference should be audio only;
 * false, otherwise.
 * @returns {{
*     type: SET_CARMODE_AUDIO_ONLY,
*     audioOnlyCarMode: boolean,
* }}
*/
export function setCarModeAudioOnly(audioOnlyCarMode: boolean) {
    return (dispatch: Dispatch<any>) => {
        dispatch({
            type: SET_CARMODE_AUDIO_ONLY,
            audioOnlyCarMode
        });
    };
}

/**
 * Toggles the audio-only flag for the current MHConference.
 *
 * @returns {Function}
 */
export function toggleAudioOnly() {
    return (dispatch: Dispatch<any>, getState: Function) => {
        const { enabled } = getState()['features/base/audio-only'];

        return dispatch(setAudioOnly(!enabled, true));
    };
}

/**
 * Toggles the audio-only flag for the current MHConference.
 *
 * @returns {Function}
 */
export function toggleCarModeAudioOnly() {
    return (dispatch: Dispatch<any>, getState: Function) => {
        const { inCarModeEnabled } = getState()['features/base/audio-only'];

        return dispatch(setCarModeAudioOnly(!inCarModeEnabled));
    };
}
